import { get, post } from './http';

const baseUrl = process.env.VUE_APP_BASE_URL;

// 获取场景列表
const getScene = (params) => get(`${baseUrl}/outline/option/scene`, params);
// 示例列表
const getExampleList = (params) => get(`${baseUrl}/outline/topicExample`, params);
// 获取篇幅列表
const getPage = (params) => get(`${baseUrl}/outline/option/pageSize`, params);
// 获取受众
const getUser = (params) => get(`${baseUrl}/outline/option/audience`, params);
// 获取单页字数列表
const getVerbosity = (params) => get(`${baseUrl}/outline/option/verbosity`, params);
// 获取语言设置列表
const getLanguage = (params) => get(`${baseUrl}/outline/option/language`, params);
// 获取历史提问
const getHistory = (params) => get(`${baseUrl}/history/outline`, params);
// 删除历史提问记录
const deleteHistoryItem = (data) => post(`${baseUrl}/history/outline/delete`, data);
// 灵感创作示例
const getExampleCreation = (params) => get(`${baseUrl}/slide/example/list`, params);
// 使用灵感示例
const useExample = (data) => post(`${baseUrl}/slide/example/use`, data);

export default {
  getScene,
  getExampleList,
  getPage,
  getUser,
  getHistory,
  deleteHistoryItem,
  getExampleCreation,
  useExample,
  getVerbosity,
  getLanguage,
}
